import { Button, Icon, Message, Segment } from "semantic-ui-react";

const STATE_CONFIG = {
  4: {
    label: "Aprobada",
    color: "green",
    icon: "check circle",
    message:
      "Tu pago fue aprobado. Recibirás una confirmación por correo electrónico.",
  },
  6: {
    label: "Declinada",
    color: "red",
    icon: "times circle",
    message:
      "Tu pago fue rechazado por el banco. Si crees que es un error, intenta de nuevo.",
  },
  7: {
    label: "En procesamiento",
    color: "yellow",
    icon: "clock",
    message:
      "Tu pago está siendo procesado por el banco. Esto puede tardar unos minutos. Recibirás una confirmación por correo electrónico.",
  },
};

const DEFAULT_STATE = {
  label: "Estado desconocido",
  color: "grey",
  icon: "question circle",
  message:
    "No pudimos determinar el estado de tu transacción. Revisa tu historial de pagos en unos minutos.",
};

const ConfirmationMessagePayu = ({ history, location }) => {
  const params = new URLSearchParams(location?.search);
  const description = params.get("description");
  const transactionState = params.get("transactionState");

  const config = STATE_CONFIG[transactionState] ?? DEFAULT_STATE;

  return (
    <Segment style={{ margin: 30 }}>
      <Message color={config.color} icon>
        <Icon name={config.icon} />
        <Message.Content>
          <Message.Header>Transacción {config.label}</Message.Header>
          {description && <p>Descripción: {description}</p>}
          <p>{config.message}</p>
        </Message.Content>
      </Message>
      <Button
        style={{ backgroundColor: "#B0193F", color: "#fff" }}
        onClick={() => history.push("/dashboard/payments")}
        content="Ir a mis pagos"
      />
    </Segment>
  );
};

export default ConfirmationMessagePayu;
